// extracted by mini-css-extract-plugin
export default {"titulo":"ContenedorVideollamada_titulo__VS+-n","contenedor":"ContenedorVideollamada_contenedor__w5096"};